import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPreventScroll]',
  standalone: true,
})
export class PreventScrollDirective {
  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent): void {
    if ((event.currentTarget as HTMLInputElement).type === 'number') {
      event.preventDefault();
    }
  }
}
